<template>
  <div
    v-if="(!option.needActive || userActive) && (!option.needNoor || hasNoor)"
  >
    <app-option
      v-if="option.route"
      :icon="option.icon"
      :title="option.title"
      :route="option.route"
      :value="option.value"
      @closeSlider="$emit('closeSlider')"
    />
    <template v-else-if="showHeader">
      <app-title :title="option.title" />
    </template>
  </div>
</template>

<script>
import Vue from "vue";
import router from "@/router";
import SliderTitle from "./Title";
import SliderOption from "./Option";

export default {
  props: ["option", "showHeader"],
  components: {
    appTitle: SliderTitle,
    appOption: SliderOption,
  },
  computed: {
    userActive() {
      return this.$store.getters.userInfo.Active;
    },
    hasNoor() {
      return this.$store.getters.userInfo.HasNoor;
    },
  },
};
</script>
<style scoped>
.options {
  display: block;
  padding: 0px;
  cursor: pointer;
}
</style>
